import React from 'react';

type Props = {
  slug: string;
  recipeId: string;
  currentLocale: string;
  servingSize?: number;
  config?: {
    [locale: string]: {
      id: string;
      prefix?: string;
    };
  };
};

const HappyCartButton = ({ config, slug, currentLocale, recipeId, servingSize }: Props) => {
  if (!config) {
    return null;
  }

  const channelId = config[currentLocale]?.id;

  if (!channelId) {
    return null;
  }

  const prefix = config[currentLocale]?.prefix || 'dr-oetker';

  // TODO: Remove this once the recipeId is working for AT. At the moment only the slug is working for AT.
  const buttonRecipeId = currentLocale === 'de_AT' ? slug : recipeId;

  return (
    <div className="print:hidden">
      {/* @ts-ignore */}
      <happy-cart channel-id={channelId} />
      {/* @ts-ignore */}
      <happy-cart-button recipe-id={`${prefix}-${buttonRecipeId}`} serving-size={servingSize} />
    </div>
  );
};

export default HappyCartButton;
